import { render } from "./Notice.vue?vue&type=template&id=4b06bc7e&scoped=true"
import script from "./Notice.vue?vue&type=script&lang=js"
export * from "./Notice.vue?vue&type=script&lang=js"

import "./Notice.vue?vue&type=style&index=0&id=4b06bc7e&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/todaymeal_front/todaymeal_front/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b06bc7e"]])

export default __exports__